module.exports = __webpack_public_path__ + "img/stage2_large.a24450e6.png";